var _title, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTempCross = function SvgTempCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    fill: "none",
    style: {},
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.038930668709497,30.249999377551784 C11.536585242597921,30.249999377551784 7.920040001679714,27.224999439796605 7.920040001679714,23.459210628395603 C7.920040001679714,21.730591219520615 8.731933016942591,20.063816253817517 10.134254194070383,18.82911211255711 V5.2474505864687 C10.134254194070383,2.345921062839561 12.939015005122965,0 16.407923591375692,0 C19.876930891625918,0 22.681592988681,2.345921062839561 22.681592988681,5.2474505864687 V13.890295547515487 H27.110001630662833 V15.124999688775892 H21.20542387002122 V5.2474505864687 C21.20542387002122,3.024999937755178 19.065008262163797,1.234695738482801 16.407923591375692,1.234695738482801 C13.75083892058759,1.234695738482801 11.610423312730163,3.024999937755178 11.610423312730163,5.2474505864687 V19.322943352395644 L11.389007816330945,19.508140570807097 C10.134254194070383,20.557647493656045 9.396199248939743,21.97754885332791 9.396199248939743,23.459210628395603 C9.396199248939743,26.545886953770566 12.348507872060052,29.01529523629138 16.038930668709497,29.01529523629138 C19.72925475136144,29.01529523629138 22.681592988681,26.545886953770566 22.681592988681,23.459210628395603 C22.681592988681,22.2245064871352 22.238761995882566,21.113239148890415 21.353001296288195,20.1254926414373 L20.467339310691337,19.137746133984187 H21.943508429351112 H22.238761995882566 L22.460177492281783,19.38470376779148 C23.49351561814313,20.557647493656045 24.08392403720854,21.97754885332791 24.08392403720854,23.459210628395603 C24.157762107340776,27.224999439796605 20.541177380823573,30.249999377551784 16.038930668709497,30.249999377551784 z",
    fill: "#d50b0b",
    id: "svg_1",
    className: "",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3601 11.6816H22.1262V13.151H27.3601V11.6816Z",
    fill: "#eb1a1a",
    id: "svg_2",
    className: "",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3601 6.53882H22.1262V8.00821H27.3601V6.53882Z",
    fill: "#d50b0b",
    id: "svg_3",
    className: "",
    fillOpacity: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.892400176160166,5.877439992355898 H15.396999999999963 V19.46419967304606 H16.892400176160166 V5.877439992355898 z",
    fill: "#d50b0b",
    id: "svg_4",
    className: "",
    fillOpacity: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.01970012874019,20.84180076889325 C13.996198058152268,20.84180076889325 12.406200013673104,22.250466852704797 12.406200013673104,24.04339382642076 C12.406200013673104,25.83623364638531 13.996198058152268,27.244899730196856 16.01970012874019,27.244899730196856 C18.043202199328114,27.244899730196856 19.63320024380728,25.83623364638531 19.63320024380728,24.04339382642076 C19.63320024380728,22.250466852704797 18.043202199328114,20.84180076889325 16.01970012874019,20.84180076889325 zM16.01970012874019,25.964262507185865 C14.791100423975774,25.964262507185865 13.851600059699939,25.131857027603836 13.851600059699939,24.04339382642076 C13.851600059699939,22.95484347148627 14.791100423975774,22.122437991904256 16.01970012874019,22.122437991904256 C17.24829983350461,22.122437991904256 18.187800197780444,22.95484347148627 18.187800197780444,24.04339382642076 C18.187800197780444,25.131857027603836 17.24829983350461,25.964262507185865 16.01970012874019,25.964262507185865 z",
    fill: "#d50b0b",
    id: "svg_5",
    className: "",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0404b8",
    fillOpacity: 1,
    stroke: "#eb1a1a",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_14",
    d: "M3.3808691466071012,10.49998378678552 L27.999999431717537,23.99999977589697 L3.3808691466071012,10.49998378678552 z",
    style: {
      color: "rgb(211, 74, 99)"
    },
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d50b0b",
    fillOpacity: 1,
    stroke: "#eb1a1a",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_16",
    d: "M42.78568630133361,88.49998442083597 ",
    style: {
      color: "rgb(211, 74, 99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d50b0b",
    fillOpacity: 1,
    stroke: "#eb1a1a",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_18",
    d: "M9.1897461858426,3.5275097601899508 L23.098344019935496,29.978310970111725 L9.1897461858426,3.5275097601899508 z",
    style: {
      color: "rgb(211, 74, 99)"
    },
    className: "",
    transform: "rotate(82.37525177001953 16.144044876098633,16.752910614013672) "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d50b0b",
    fillOpacity: 1,
    stroke: "#eb1a1a",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_20",
    d: "M39.78568630133361,24.499984420835972 ",
    style: {
      color: "rgb(211, 74, 99)"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTempCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tempCross.c40e8ed9.svg";
export { ForwardRef as ReactComponent };